import React from 'react';
import { useFetchNoUser } from '../hooks/useFetchNoUser';
import {
  OutlinedInput,
  InputLabel,
  FormControl,
  Select,
  MenuItem,
} from '@mui/material/';

function SelectRace({ raceId, setRaceId, disabled }) {
  const { error, isPending, data } = useFetchNoUser(
    'https://pcapi.bi-oss.co.za/shared/race',
  );

  return (
    <FormControl fullWidth>
      <InputLabel id="selectrace">Select Race*</InputLabel>

      <Select
        labelId="race"
        id="race"
        onChange={(e) => setRaceId(e.target.value)}
        input={<OutlinedInput label="selectrace" />}
        required
        value={raceId}
        disabled={disabled}
      >
        {!error &&
          !isPending &&
          data &&
          data.map((data) => (
            <MenuItem key={data.id} value={data.id}>
              {data.race}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
}

export default SelectRace;
